import { createAction } from 'redux-act';

export const getQuizesAnswers = createAction();
export const receivedQuizesAnswers = createAction();
export const quizesAnswersError = createAction();
export const updateCurrentStateofQuizesAnswers = createAction();
